<template>
    <div class="sa-list-component">
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <!--secondary btn-toolbar sa-margin-right float-sm-right-->
                <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right"
                    :hidden="btnAggiungi" @click="onClickAggiungi" class="mb-2">
                    <i class="fas fa-plus"></i>
                    Aggiungi
                </b-button>
                <template v-if="items.length > 0">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields"
                        :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                        <template v-slot:cell(createDate)="{ item }">
                            <span>{{ formatDateTime(item.createDate) }}</span>
                        </template>
                        <template #cell(idPri)="{ item }">
                            <span> {{ item.idPri ?
                                item.idPri : 'Codice PRI non generato' }}</span>
                        </template>
                        <template #cell(confermaAsp)="{ item }">
                            <span> {{ item.confermaAsp ?
                                `✅ ${formatDate(item.dataOraConfermaAsp)}` : '❌' }}</span>
                        </template>


                        <template #cell(action)="{ item }">
                            <b-container class="bv-example-row" style=" display:flex;gap:4px !important">
                                <b-button size="sm" v-if="item.confermaAsp" key="crea-impegnativa"
                                    variant="btn btn-outline-info waves-effect waves-light width-sm no-text"
                                    @click="onClickCreaImpegnativa(item)" title="Crea Impegnativa">
                                    <i class="bi bi-file-medical-fill"></i>
                                </b-button>
                                <b-button size="sm" v-if="!item.confermaAsp" key="crea-asp"
                                    variant="btn btn-outline-success waves-effect waves-light width-sm no-text"
                                    @click="onClickConfermaPri(item)" title="Conferma Pri">
                                    <i class="fas fa-check"></i>
                                </b-button>
                                <b-button size="sm" class=" no-text"
                                    variant="btn btn-outline-primary waves-effect waves-light width-sm no-text"
                                    @click="onViewPri(item)" title="Visualizza">
                                    <font-awesome-icon icon="eye" />
                                </b-button>
                            </b-container>
                            <!-- <b-button size="sm" class="mr-1 ml-1 no-text" variant="outline-danger"
                                @click="onClickDeleteScala(item)" title="Elimina">
                                <font-awesome-icon icon="trash" />
                            </b-button> -->
                        </template>
                    </b-table>
                </template>
                <template v-else>
                    <NoDataComponent ref="cmpNoDataComponent"
                        title="Non sono presenti Progetti Riabilitativi Individuali per il paziente" nome="no-data"
                        subtitle="" icon="fas fa-users" />
                </template>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                        size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <b-modal title="Crea/Modifica P.R.I" centered scrollable footer-tag="footer" @shown="onShownModalPriEdit"
            @hide="onHide" no-close-on-backdrop no-close-on-esc hide-header-close ref="mdlPriEditModal"
            id="mdlPriEditModal" size="xl" style="height: 100%;">
            <ProgettoRiabilitativoIndividualeEditComponent ref="mdlPriEditComponent" @afterSave="onAfterSave" />
            <template #modal-footer>
                <div class="d-flex justify-content-end w-100">
                    <b-button size="sm" variant="danger" class="ml-2" @click="onAnnulla()">
                        {{ !priSelezionato.primaryKey ? "Annulla" : "Chiudi" }}</b-button>
                    <b-button size="sm" variant="success" class="ml-2" v-if="!priSelezionato.confermaAsp"
                        @click="onSalvaProgettoRiabilitativo()">Salva
                    </b-button>
                </div>
            </template>
        </b-modal>
        <AccettazioneSsnImpegnativaModalComponent ref="mdlAccettaazioneImpegnativa" :isEdit="true"
            :internalSave="true" />
        <!-- :prestazioni="jsonData.ricette" :idAccettazione="jsonData.id"
            :codiceFiscalePaziente="jsonData.accettazioneAnagrafica.identificativo"
            @onAggiungiImpegnativa="onAggiungiImpegnativa" @onChangeTipologiaRicetta="onChangeTipologiaRicetta"
            @onModificaImpegnativa="onModificaImpegnativa" @onAggiungiImpegnativaBe="onAggiungiImpegnativaBe"
            @reload="onReload" -->
    </div>
</template>

<script>
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
import ProgettoRiabilitativoIndividualeEditComponent from "./ProgettoRiabilitativoIndividualeEditComponent.vue"
import AccettazioneSsnImpegnativaModalComponent from "../../../accettazione/ssn/components/AccettazioneSsnImpegnativaModalComponent.vue";
import NoDataComponent from "../../../../template/components/utility/NoDataComponent.vue";
import toast from "../../../../template/layout/utility/sa-toast";
export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    mixins: [UtilityMixin],
    components: { ProgettoRiabilitativoIndividualeEditComponent, AccettazioneSsnImpegnativaModalComponent, NoDataComponent },
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pathResource: "/progettoriabilitativoindividuale",
            btnAggiungi: false,
            priFilter: { idAccettazione: null },
            idAccettazione: "",
            isView: false,
            codicePri: null,
            priSelezionato: {
                confermaAsp: false
            },
            numeratore: {},
            presidio: {},
            jsonData: {
                idPri: "",
                accettazioneAnagrafica: {}
            },
            items: [],
            fields: [
                {
                    label: "Codice Identificativo P.R.I",
                    key: "idPri",
                    sortable: true,
                    thStyle: "width: 14rem",
                },
                {
                    label: "Data/Ora Compilazione",
                    key: "createDate",
                    sortable: true,
                    thStyle: "width: 18rem",
                },
                {
                    label: "Autore",
                    key: "createUser",
                    sortable: true,
                    thStyle: "width: 18rem",
                },
                {
                    label: "Confermata ASP",
                    key: "confermaAsp",
                    sortable: true,
                    thStyle: "width: 18rem",
                },
                {
                    label: "",
                    key: "action",
                    thStyle: "width: 8rem",
                    tdClass: "text-center",
                },
            ],
        };
    },
    mounted() {
        this.getPresidio();
    },
    methods: {
        init(jsonData) {

            this.idAccettazione = jsonData.id;
            this.priFilter.idAccettazione = jsonData.id;
            this.jsonData = jsonData;
            this.loadData();

        },
        onHide() {
            this.priSelezionato = {
                confermaAsp: false
            }
        },
        loadData() {
            let me = this;
            this.loadDataResources(me.pathResource, me.priFilter, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.$emit("afterLoadData");
        },
        loadDataError(error) {
            let me = this;
            console.log(error);
            me.$emit("afterLoadData");
        },

        onClickAggiungi() {
            this.openModalPriEdit();

        },
        onViewPri(item) {
            this.priSelezionato = item;
            this.$refs.mdlPriEditModal.show();
            this.isView = true;

        },
        openModalPriEdit() {
            this.$refs.mdlPriEditModal.show();
        },
        hideModalPriEdit() {
            this.$refs.mdlPriEditModal.hide();
        },
        onAnnullaConferma() {

        },
        onShownModalPriEdit() {
            if (!this.isView) {
                this.$refs.mdlPriEditComponent.init(this.jsonData);
            } else {
                this.$refs.mdlPriEditComponent.setViewPri(this.priSelezionato, this.jsonData);
            }

        },
        onHideMdlConfermaPri() {
            this.priSelezionato = { confermaAsp: false };
        },
        onShownMdlConfermaPri() { },
        onClickCreaImpegnativa(item) {
            this.$refs.mdlAccettaazioneImpegnativa.creaImpegnativaTramitePri(this.jsonData, item);

        },
        onClickVisualizzaScala(item) {
            let me = this;
            me.$refs.mdlPriEditModal.visualizzaScala(item);
        },
        onClickConfermaPri(item) {
            this.priSelezionato = item;

            this.$bvModal
                .msgBoxConfirm("Conferma ASP e generare codice P.R.I ? ", {
                    title: "Conferma ASP",
                    size: "sm",
                    okTitle: "Conferma",
                    cancelTitle: "Annulla",
                    okVariant: "outline-success",
                    cancelVariant: "outline-secondary",
                    headerClass: "sa-msg-header-success",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                    noCloseOnBackdrop: true,
                    noCloseOnEsc: true,
                })
                .then((v) => {
                    console.log(v);
                    if (v) {
                        this.openShowModalLoading();
                        item.codiceStruttura = this.presidio.codiceStruttura;
                        console.log(this.presidio);

                        let link = process.env.VUE_APP_PATH_API + "/progettoriabilitativoindividuale";
                        axios.put(link + "/" + item.id + "/conferma", item).then((response) => {
                            response;
                            toast.success("P.R.I Confermato con successo");
                            this.$refs.mdlPriEditModal.hide();
                            this.closeShowModalLoading();
                            this.loadData();
                        }).catch((err) => {
                            this.closeShowModalLoading();
                            toast.error(err.response.data.messaggio)
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        onAfterSave() {
            let me = this;
            me.loadData();
        },


        onAnnulla() {
            this.isView = false;
            this.hideModalPriEdit();

        },


        onConfermaPri() {
            this.openShowModalLoading();
            let link = process.env.VUE_APP_PATH_API + "/progettoriabilitativoindividuale";
            axios.put(link + "/" + this.priSelezionato.id, this.priSelezionato).then((response) => {
                response;
                toast.success("P.R.I Confermato con successo");
                this.$refs.mdlPriEditModal.hide();
                this.closeShowModalLoading();
                this.loadData();
            }).catch((err) => {
                this.closeShowModalLoading();
                toast.error(err.response.data.messaggio)
            });
        },


        onSalvaProgettoRiabilitativo() {
            this.openShowModalLoading()
            let jsonToSave = this.$refs.mdlPriEditComponent.getJsonData();
            delete jsonToSave.sesso;
            delete jsonToSave.eta;
            delete jsonToSave.domicilio;
            delete jsonToSave.residenza;
            delete jsonToSave.dataNascita;
            delete jsonToSave.codiceStruttura
            let link = process.env.VUE_APP_PATH_API + "/progettoriabilitativoindividuale";
            if (this.isView) {
                axios.put(link + "/" + jsonToSave.id, jsonToSave).then((response) => {
                    response;
                    toast.success("Modificato con successo");
                    this.$refs.mdlPriEditModal.hide();
                    this.closeShowModalLoading();
                    this.loadData();
                }).catch((err) => {
                    this.closeShowModalLoading();
                    toast.error(err.response.data.messaggio)
                });
            } else {
                axios.post(link, jsonToSave).then((response) => {
                    response;
                    toast.success("salvato con successo");
                    this.$refs.mdlPriEditModal.hide();
                    this.closeShowModalLoading();
                    this.loadData();
                }).catch((err) => {
                    this.closeShowModalLoading();
                    toast.error(err.response.data.messaggio)
                });
            }
        },
        getPresidio() {
            let tmpPresidio = window.localStorage.getItem("presidio");
            if (tmpPresidio) {
                this.presidio = JSON.parse(tmpPresidio);
            }
        },
    },
};
</script>

<style></style>
